export default {
  tax: "Tax",
  addTax: "AddTax",
  editTax: "EditTax",
};
